import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AiChatRequest,
  AiChatResponse,
  AiExtractRequest,
  AiExtractResponse,
} from '@fund-base/types/ai/ai-assistant.types';
import {
  aiAssistantChatApiUrl,
  aiExtractApiUrl,
  aiOnboardingChatApiUrl,
  aiOnboardingConfirmApiUrl,
  aiVisitorAssistantChatApiUrl,
  aiVisitorExtractApiUrl,
} from '@fund-base/constants/ai/ai-assistant.constants';
import {
  OnboardingChatRequest,
  OnboardingChatResponse,
  OnboardingConfirmRequest,
  OnboardingConfirmResponse,
} from '@fund-base/types/ai/onboarding-ai.types';

@Injectable({ providedIn: 'root' })
export class AiAssistantService {
  constructor(private httpClient: HttpClient) {}

  chat(request: AiChatRequest, isVisitor = false): Observable<AiChatResponse> {
    const url = isVisitor ? aiVisitorAssistantChatApiUrl : aiAssistantChatApiUrl;
    return this.httpClient.post<AiChatResponse>(url, request);
  }

  extractFilters(text: string, isVisitor = false): Observable<AiExtractResponse> {
    const url = isVisitor ? aiVisitorExtractApiUrl : aiExtractApiUrl;
    return this.httpClient.post<AiExtractResponse>(url, { text } as AiExtractRequest);
  }

  onboardingChat(request: OnboardingChatRequest): Observable<OnboardingChatResponse> {
    return this.httpClient.post<OnboardingChatResponse>(aiOnboardingChatApiUrl, request);
  }

  confirmOnboarding(request: OnboardingConfirmRequest): Observable<OnboardingConfirmResponse> {
    return this.httpClient.post<OnboardingConfirmResponse>(aiOnboardingConfirmApiUrl, request);
  }
}
